import React, { useState } from 'react';
import { Switch, Tooltip } from '@amzn/storm-ui';
import { usePageHeaderBundle } from '../../../../providers/PantherLocalizationProvider';
import { ATC_EXTERNAL_TOGGLE } from '../../../../commons/constants';
import { ExternalToggleTriggerWrapper } from '../UtilityMenu/styles';

const ExternalSwitch: React.VFC<{
  isDisabled: boolean;
}> = ({ isDisabled }) => {
  const bundle = usePageHeaderBundle();

  const [toggled, setToggled] = useState(
    window.sessionStorage.getItem(ATC_EXTERNAL_TOGGLE) === 'true',
  );

  const onChange = (toggled) => {
    if (toggled) {
      window.sessionStorage.setItem(ATC_EXTERNAL_TOGGLE, 'true');
    } else {
      window.sessionStorage.removeItem(ATC_EXTERNAL_TOGGLE);
    }
    setToggled(toggled);
    window.location.reload();
  };

  return (
    <Switch
      id="atc-external-toggle"
      toggled={toggled}
      onChange={onChange}
      label={bundle.getMessage('page-header-external-toggle')}
      switchLabel={bundle.getMessage('page-header-external-toggle')}
      disabled={isDisabled}
    />
  );
};

export const ExternalToggle: React.VFC<{
  isDisabled: boolean;
}> = ({ isDisabled }) => {
  const bundle = usePageHeaderBundle();
  if (!isDisabled) return <ExternalSwitch isDisabled={isDisabled} />;
  return (
    <ExternalToggleTriggerWrapper>
      <Tooltip
        trigger={
          <span>
            <ExternalSwitch isDisabled={isDisabled} />
          </span>
        }
        message={bundle.getMessage(
          'page-header-external-toggle-internal-only-tooltip',
        )}
        position="bottom"
        withCloseButton={false}
      />
    </ExternalToggleTriggerWrapper>
  );
};
